import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Loader } from "components/Common/Loader";
import Render from "components/Common/Render";
import PreRegisterAddCardForm from "components/Home/Preregister/PreRegisterAddcardForm";
import { useAppSelector } from "hooks/useRedux";
import { http } from "middleware/apiMiddleware";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { RootState } from "store";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY || "");

const PreRegisterForm = ({
  onGoBack,
  topupAmount,
  referralCode,
  onSuccess,
  setErrorMessage,
}: {
  onGoBack: () => void;
  topupAmount: number;
  referralCode: string;
  onSuccess: () => void;
  setErrorMessage: (message: string) => void;
}) => {
  const [clientSecret, setClientSecret] = useState("");
  const [isCreatingIntent, setIsCreatingIntent] = useState(false);
  const selectedBusiness = useAppSelector(
    (state: RootState) => state.businesses.business
  );

  const fetchClientSecret = useCallback(async () => {
    try {
      setIsCreatingIntent(true);
      // Create card setup intent
      const { data, error } = await http.post(
        `/business/${selectedBusiness?.uuid}/pre-signup`,
        {
          formData: {
            topUpAmount: topupAmount,
            referralCode,
          },
        }
      );
      if (!data && !!error && error?.status == 400) {
        setErrorMessage(error["message"] || "Something went wrong");
        onGoBack();
      }
      if (!!data && !error) setClientSecret(data?.setupIntentClientSecret);
    } catch (error) {
      console.error("error activating stripe module");
    } finally {
      setIsCreatingIntent(false);
    }
  }, []);

  useEffect(() => {
    fetchClientSecret();
  }, []);

  return (
    <div className="w-full">
      {isCreatingIntent ? (
        <div className="flex justify-center item-center w-full">
          <Loader />
        </div>
      ) : (
        <Render when={!!clientSecret}>
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <PreRegisterAddCardForm
              clientSecret={clientSecret}
              onGoBack={onGoBack}
              onSuccess={() => {
                onSuccess && onSuccess();
              }}
              selectedBusiness={selectedBusiness}
            />
          </Elements>
        </Render>
      )}
    </div>
  );
};

export default PreRegisterForm;
